<!-- Backdrop for mobile drawer -->
<div
  class="sidebar-backdrop"
  *ngIf="(sidebarState$ | async)?.isMobile && (sidebarState$ | async)?.isDrawerOpen"
  (click)="closeDrawer()"
></div>

<div
  class="sidebar-wrap"
  *ngIf="sidebarState$ | async as sidebar"
  [class.minimized]="
    sidebar.isMinimized && !sidebar.isHovered && !sidebar.isSideBySide && !sidebar.isMobile
  "
  [class.expanded-overlay]="
    (sidebar.isMinimized && sidebar.isHovered && !sidebar.isSideBySide && !sidebar.isMobile) ||
    (sidebar.isMobile && sidebar.isDrawerOpen)
  "
  [class.side-by-side]="sidebar.isSideBySide && !sidebar.isMobile"
  [class.mobile-drawer]="sidebar.isMobile"
  [class.drawer-open]="sidebar.isMobile && sidebar.isDrawerOpen"
  [class.drawer-closed]="sidebar.isMobile && !sidebar.isDrawerOpen"
  (mouseleave)="onSidebarMouseLeave()"
>
  <div class="img-wrap">
    <div class="logo-container">
      <!-- Full logo - show when not minimized or hovered or in side-by-side mode or mobile drawer open -->
      <lib-logo
        *ngIf="
          !sidebar.isMinimized ||
          sidebar.isHovered ||
          sidebar.isSideBySide ||
          (sidebar.isMobile && sidebar.isDrawerOpen)
        "
        variant="normal"
        size="medium"
        [customWidth]="sidebar.isMobile ? '78.4px' : '86.4px'"
        alt="Merchant Portal Logo"
      >
      </lib-logo>

      <!-- Minimized logo - show when minimized and not hovered and not in side-by-side mode and not mobile -->
      <div
        *ngIf="
          sidebar.isMinimized && !sidebar.isHovered && !sidebar.isSideBySide && !sidebar.isMobile
        "
        class="minimized-logo-container"
        (mouseenter)="logoHovered = true"
        (mouseleave)="logoHovered = false"
      >
        <lib-logo
          variant="logo-only"
          customWidth="24px"
          alt="Logo"
          class="minimized-logo"
          *ngIf="!logoHovered"
        >
        </lib-logo>

        <!-- Collapsible button - show on minimized logo hover -->
        <button
          *ngIf="logoHovered"
          (click)="toggleSideBySide()"
          class="collapsible-btn"
          [attr.aria-label]="'Expand sidebar'"
        >
          <app-svg-loader [url]="'sidebar-expand.svg'"></app-svg-loader>
        </button>
      </div>

      <!-- Collapsible button - show when in overlay mode (hovered) -->
      <button
        *ngIf="sidebar.isHovered && sidebar.isMinimized && !sidebar.isSideBySide"
        (click)="toggleSideBySide()"
        class="collapsible-btn overlay-toggle-btn"
        [attr.aria-label]="'Pin sidebar'"
      >
        <app-svg-loader [url]="'sidebar-expand.svg'"></app-svg-loader>
      </button>

      <!-- Collapsible button - show when in side-by-side mode -->
      <button
        *ngIf="sidebar.isSideBySide"
        (click)="toggleSideBySide()"
        class="collapsible-btn"
        [attr.aria-label]="'Minimize sidebar'"
      >
        <app-svg-loader [url]="'sidebar-expand.svg'"></app-svg-loader>
      </button>

      <button
        *ngIf="sidebar.isMobile && sidebar.isDrawerOpen"
        (click)="closeDrawer()"
        class="collapsible-btn"
        [attr.aria-label]="'Close menu'"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <div class="bridge-content"></div>

  <!-- Menu container - show labels only when not minimized OR when hovered OR when in side-by-side mode -->
  <div
    class="menu-container"
    style="overflow-y: auto; flex: 1; scrollbar-width: thin"
    (mouseenter)="onMenuMouseEnter()"
  >
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <a
          *ngIf="!node.hidden"
          [routerLink]="node.routerLink"
          class="sidebar-menu"
          (click)="activateMenu(node)"
          (keydown)="activateMenu(node)"
          [class.active]="node.isActive"
          tabindex="0"
        >
          <div class="menu-item-content">
            <i *ngIf="node?.icon && node.icon !== '-'" class="{{ node.icon }} sidebar-icon"></i>
            <app-svg-loader
              *ngIf="node?.customIcon && node.customIcon !== '-'"
              [url]="node?.customIcon"
              class="sidebar-custom-icon"
              alt="sidebar-icon"
            ></app-svg-loader>
            <span
              *ngIf="
                !sidebar.isMinimized ||
                sidebar.isHovered ||
                sidebar.isSideBySide ||
                (sidebar.isMobile && sidebar.isDrawerOpen)
              "
              class="menu-label"
              >{{ node.label }}</span
            >
          </div>
        </a>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div
          class="mat-tree-node sidebar-menu"
          matTreeNodeToggle
          [class.active]="node.isActive"
          tabindex="0"
          (click)="nodeClicked(node)"
        >
          <div class="menu-item-content">
            <i *ngIf="node.icon && node.icon !== '-'" class="{{ node.icon }} sidebar-icon"></i>
            <app-svg-loader
              *ngIf="node?.customIcon && node.customIcon !== '-'"
              [url]="node?.customIcon"
              class="sidebar-custom-icon"
              alt="sidebar-icon"
            ></app-svg-loader>
            <span
              *ngIf="
                !sidebar.isMinimized ||
                sidebar.isHovered ||
                sidebar.isSideBySide ||
                (sidebar.isMobile && sidebar.isDrawerOpen)
              "
              class="menu-label"
              >{{ node.label }}</span
            >
            <button
              *ngIf="
                !sidebar.isMinimized ||
                sidebar.isHovered ||
                sidebar.isSideBySide ||
                (sidebar.isMobile && sidebar.isDrawerOpen)
              "
              class="expand-button sidebar-icon"
              mat-icon-button
              matTreeNodeToggle
              (click)="nodeClicked(node)"
              [attr.aria-label]="'Toggle ' + node.label"
            >
              <i
                [ngClass]="treeControl.isExpanded(node) ? 'pi pi-angle-up' : 'pi pi-angle-down'"
              ></i>
            </button>
          </div>
        </div>
        <div
          *ngIf="
            !sidebar.isMinimized ||
            sidebar.isHovered ||
            sidebar.isSideBySide ||
            (sidebar.isMobile && sidebar.isDrawerOpen)
          "
          [class.example-tree-invisible]="!treeControl.isExpanded(node)"
          role="group"
        >
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
</div>
